// pages/DetalleCertificacion.jsx

import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../services/api';
import '../styles/DetalleCertificacion.css';
import ModalSeleccionarCliente from '../components/ModalSeleccionarCliente';
import { useFiscal } from '../hooks/useFiscal';

const DetalleCertificacion = () => {
  const fiscal = useFiscal();
  const { id } = useParams();
  const navigate = useNavigate();
  
  const [certificacion, setCertificacion] = useState(null);
  const [proyecto, setProyecto] = useState(null);
  const [loading, setLoading] = useState(true);
  const [procesando, setProcesando] = useState(false);
  const [clientesDisponibles, setClientesDisponibles] = useState([]); 
  const [modalClienteOpen, setModalClienteOpen] = useState(false);

  useEffect(() => {
    cargarDatos();
  }, [id]);

  const cargarDatos = async () => {
    try {
      setLoading(true);
      const response = await api.get(`/certificaciones/${id}`);
      setCertificacion(response.data.certificacion);
      setProyecto(response.data.certificacion.proyecto);
    } catch (error) {
      console.error('Error cargando certificación:', error);
      alert('Error al cargar certificación');
      navigate('/certificaciones');
    } finally {
      setLoading(false);
    }
  };

  const formatearMoneda = (valor) => {
    return new Intl.NumberFormat('es-DO', {
      style: 'currency',
      currency: fiscal.moneda?.codigo || 'DOP'
    }).format(valor || 0);
  };

  const formatearFecha = (fecha) => {
    if (!fecha) return '-';
    return new Date(String(fecha).substring(0,10) + 'T00:00:00').toLocaleDateString('es-DO', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  const getEstadoBadge = (estado) => {
    const badges = {
      'borrador': { color: '#6b7280', label: 'BORRADOR', icon: '📝' },
      'revisión': { color: '#f59e0b', label: 'EN REVISIÓN', icon: '🔍' },
      'aprobada': { color: '#3b82f6', label: 'APROBADA', icon: '✅' },
      'facturada': { color: '#10b981', label: 'FACTURADA', icon: '💰' }
    };
    return badges[estado] || badges.borrador;
  };

  // ============================================
  // CAMBIOS DE ESTADO
  // ============================================

 const handleEnviarRevision = async () => {
  if (!window.confirm('¿Enviar esta certificación a revisión?')) return;

  try {
    setProcesando(true);
   await api.put(`/certificaciones/${id}/cambiar-estado`, {
      estado: 'revisión'
    });
    alert('✅ Certificación enviada a revisión');
    cargarDatos();
  } catch (error) {
    console.error('Error:', error);
    alert(error.response?.data?.error || 'Error al cambiar estado');
  } finally {
    setProcesando(false);
  }
};

const handleAprobar = async () => {
  const aprobadoPor = prompt('¿Quién aprueba esta certificación? (Tu nombre)');
  if (!aprobadoPor) return;

  if (!window.confirm('¿Aprobar esta certificación?')) return;

  try {
    setProcesando(true);
    await api.put(`/certificaciones/${id}/cambiar-estado`, {
      estado: 'aprobada',
      aprobado_por: aprobadoPor
    });
    alert('✅ Certificación aprobada correctamente');
    cargarDatos();
  } catch (error) {
    console.error('Error:', error);
    alert(error.response?.data?.error || 'Error al aprobar certificación');
  } finally {
    setProcesando(false);
  }
};

const handleRegresarBorrador = async () => {
  const motivo = prompt('Motivo para regresar a borrador:');
  if (!motivo) return;

  try {
    setProcesando(true);
    await api.put(`/certificaciones/${id}/cambiar-estado`, {
      estado: 'borrador',
      motivo
    });
    alert('✅ Certificación regresada a borrador');
    cargarDatos();
  } catch (error) {
    console.error('Error:', error);
    alert(error.response?.data?.error || 'Error al cambiar estado');
  } finally {
    setProcesando(false);
  }
};


  const handleRegresarRevision = async () => {
  const motivo = prompt('Motivo para regresar a revisión:');
  if (!motivo) return;

  try {
    setProcesando(true);
    await api.put(`/certificaciones/${id}/cambiar-estado`, {
      estado: 'revisión',
      motivo
    });
    alert('✅ Certificación regresada a revisión');
    cargarDatos();
  } catch (error) {
    console.error('Error:', error);
    alert(error.response?.data?.error || 'Error al cambiar estado');
  } finally {
    setProcesando(false);
  }
};
  const handleEliminar = async () => {
    if (!window.confirm('¿ELIMINAR esta certificación? Esta acción no se puede deshacer.')) return;

    try {
      setProcesando(true);
      await api.delete(`/certificaciones/${id}`);
      alert('✅ Certificación eliminada');
      navigate(`/proyectos/${proyecto.id}/certificaciones`);
    } catch (error) {
      console.error('Error:', error);
      alert(error.response?.data?.error || 'Error al eliminar certificación');
      setProcesando(false);
    }
  };

const handleGenerarFactura = async () => {
  try {
    setProcesando(true);
    
    // Obtener clientes activos
    const clientesResponse = await api.get('/clientes?activos=true');
    const clientes = clientesResponse.data;
    
    if (clientes.length === 0) {
      alert('❌ No hay clientes registrados. Crea un cliente primero.');
      setProcesando(false);
      return;
    }
    
    // Guardar clientes y abrir modal
    setClientesDisponibles(clientes);
    setModalClienteOpen(true);
    setProcesando(false);
    
  } catch (error) {
    console.error('Error cargando clientes:', error);
    alert('Error al cargar clientes');
    setProcesando(false);
  }
};

const handleClienteSeleccionado = async (datosFactura) => {
  try {
    setProcesando(true);
    
    const { cliente, ncf } = datosFactura;
    
    // Confirmar generación
    let mensajeConfirmacion = `¿Generar factura por ${formatearMoneda(certificacion.monto_total)}?\n\n` +
      `Cliente: ${cliente.nombre}\n` +
      `RNC: ${cliente.rnc_cedula || 'N/A'}`;
    
    if (ncf && ncf.generar) {
      mensajeConfirmacion += `\n\nSe asignará NCF tipo B${ncf.tipo}`;
    }
    
    if (!window.confirm(mensajeConfirmacion)) {
      setProcesando(false);
      return;
    }
    
    // Preparar datos para el backend
    const payload = {
      ClienteId: cliente.id
    };
    
    // Si seleccionó NCF, agregarlo al payload
    if (ncf && ncf.generar) {
      payload.generarNcf = true;
      payload.tipo_ncf = ncf.tipo;
    }
    
    // Generar factura
    const response = await api.post(`/certificaciones/${id}/generar-factura`, payload);
    
    let mensaje = `✅ Factura ${response.data.factura.numero_factura} generada exitosamente`;
    if (response.data.factura.ncf) {
      mensaje += `\n\nNCF: ${response.data.factura.ncf}`;
    }
    
    alert(mensaje);
    
    // Recargar datos
    cargarDatos();
    
  } catch (error) {
    console.error('Error generando factura:', error);
    alert(error.response?.data?.error || 'Error al generar factura');
  } finally {
    setProcesando(false);
  }
};
  // ============================================
  // RENDER
  // ============================================

  if (loading) {
    return (
      <div className="detalle-cert-container">
        <div className="loading">
          <div className="spinner"></div>
          <p>Cargando certificación...</p>
        </div>
      </div>
    );
  }

  if (!certificacion) {
    return (
      <div className="detalle-cert-container">
        <div className="error-message">
          <p>Certificación no encontrada</p>
          <button onClick={() => navigate('/certificaciones')} className="btn-primary">
            Volver a Certificaciones
          </button>
        </div>
      </div>
    );
  }

  const estadoBadge = getEstadoBadge(certificacion.estado);

  return (
    <div className="detalle-cert-container">
      {/* Header */}
      <div className="detalle-cert-header">
        <div className="header-left">
          <button 
            className="btn-back"
            onClick={() => navigate(`/proyectos/${proyecto.id}/certificaciones`)}
          >
            ← Volver
          </button>
          <div className="header-title">
            <h1>Certificación #{certificacion.numero_certificacion}</h1>
            <span 
              className="estado-badge"
              style={{ backgroundColor: estadoBadge.color }}
            >
              {estadoBadge.icon} {estadoBadge.label}
            </span>
          </div>
        </div>

        <div className="header-actions">
          {/* ACCIONES SEGÚN ESTADO */}
          
          {/* BORRADOR */}
          {certificacion.estado === 'borrador' && (
            <>
           
              <button 
                className="btn-primary"
                onClick={handleEnviarRevision}
                disabled={procesando}
              >
                📤 Enviar a Revisión
              </button>
              <button 
                className="btn-danger"
                onClick={handleEliminar}
                disabled={procesando}
              >
                🗑️ Eliminar
              </button>
            </>
          )}

          {/* EN REVISIÓN */}
          {certificacion.estado === 'revisión' && (
            <>
              <button 
                className="btn-secondary"
                onClick={handleRegresarBorrador}
                disabled={procesando}
              >
                ⬅️ Regresar a Borrador
              </button>
              <button 
                className="btn-success"
                onClick={handleAprobar}
                disabled={procesando}
              >
                ✅ Aprobar Certificación
              </button>
            </>
          )}

          {/* APROBADA */}
          {certificacion.estado === 'aprobada' && (
            <>
              <button 
                className="btn-secondary"
                onClick={handleRegresarRevision}
                disabled={procesando}
              >
                ⬅️ Regresar a Revisión
              </button>
              <button 
                className="btn-success"
                onClick={handleGenerarFactura}
                disabled={procesando}
              >
                💰 Generar Factura
              </button>
            </>
          )}

          {/* Botón imprimir (siempre visible) */}
          <button 
            className="btn-secondary"
            onClick={() => window.print()}
          >
            🖨️ Imprimir
          </button>
        </div>
      </div>

      {/* Info del Proyecto */}
      <div className="proyecto-info-card">
        <div className="proyecto-icon">🏗️</div>
        <div className="proyecto-details">
          <h3>{proyecto.nombre}</h3>
          {proyecto.ubicacion && <p>📍 {proyecto.ubicacion}</p>}
          {proyecto.responsable && <p>👤 {proyecto.responsable}</p>}
        </div>
      </div>

      {/* Resumen de la Certificación */}
      <div className="resumen-cert-grid">
        <div className="resumen-cert-card">
          <div className="card-icon">📅</div>
          <div className="card-content">
            <span className="card-label">Fecha</span>
            <span className="card-value">{formatearFecha(certificacion.fecha)}</span>
          </div>
        </div>

        {certificacion.periodo_inicio && certificacion.periodo_fin && (
          <div className="resumen-cert-card">
            <div className="card-icon">📆</div>
            <div className="card-content">
              <span className="card-label">Período</span>
              <span className="card-value-small">
                {formatearFecha(certificacion.periodo_inicio)} - {formatearFecha(certificacion.periodo_fin)}
              </span>
            </div>
          </div>
        )}

        <div className="resumen-cert-card">
          <div className="card-icon">📦</div>
          <div className="card-content">
            <span className="card-label">Partidas</span>
            <span className="card-value">{certificacion.partidas?.length || 0}</span>
          </div>
        </div>

        <div className="resumen-cert-card highlight">
          <div className="card-icon">💰</div>
          <div className="card-content">
            <span className="card-label">Monto Total Certificado</span>
            <span className="card-value-money">{formatearMoneda(certificacion.monto_total)}</span>
          </div>
        </div>
      </div>

      {/* Card de Factura Generada */}
      {certificacion.estado === 'facturada' && certificacion.factura && (
        <div className="factura-generada-card">
          <div className="factura-header">
            <div className="factura-icon">💰</div>
            <h3>Factura Generada</h3>
          </div>
          <div className="factura-body">
            <div className="factura-info-row">
              <span className="label">Número de Factura:</span>
              <span className="value">{certificacion.factura.numero_factura}</span>
            </div>
            {certificacion.factura.ncf && (
              <div className="factura-info-row">
                <span className="label">NCF:</span>
                <span className="value">{certificacion.factura.ncf}</span>
              </div>
            )}
            <div className="factura-info-row">
              <span className="label">Monto:</span>
              <span className="value">{formatearMoneda(certificacion.factura.total)}</span>
            </div>
            <div className="factura-info-row">
              <span className="label">Estado:</span>
              <span className="badge badge-factura">{certificacion.factura.estado.toUpperCase()}</span>
            </div>
          </div>
          <button 
            onClick={() => navigate(`/facturas/${certificacion.factura.id}`)}
            className="btn-ver-factura"
          >
            👁️ Ver Factura Completa
          </button>
        </div>
      )}

      {/* Tabla de Partidas Certificadas */}
      <div className="partidas-section">
        <h2>📊 Partidas Certificadas</h2>
        
        <div className="tabla-container">
          <table className="tabla-partidas-cert">
            <thead>
              <tr>
                <th>Código</th>
                <th>Descripción</th>
                <th>Unidad</th>
                <th className="text-right">Cantidad</th>
                <th className="text-right">P. Unitario</th>
                {certificacion.partidas?.[0]?.porcentaje_ejecutado && (
                  <th className="text-right">% Ejecutado</th>
                )}
                <th className="text-right">Subtotal</th>
              </tr>
            </thead>
            <tbody>
              {certificacion.partidas?.map((partida, index) => (
                <tr key={index}>
                  <td>{partida.codigo || '-'}</td>
                  <td className="descripcion-cell">{partida.descripcion}</td>
                  <td>{partida.unidad}</td>
                  <td className="text-right">{parseFloat(partida.cantidad_ejecutada).toFixed(2)}</td>
                  <td className="text-right">{formatearMoneda(partida.precio_unitario)}</td>
                  {partida.porcentaje_ejecutado && (
                    <td className="text-right">
                      <span className="porcentaje-badge">
                        {parseFloat(partida.porcentaje_ejecutado).toFixed(2)}%
                      </span>
                    </td>
                  )}
                  <td className="text-right font-bold">
                    {formatearMoneda(partida.cantidad_ejecutada * partida.precio_unitario)}
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr className="total-row">
                <td colSpan={certificacion.partidas?.[0]?.porcentaje_ejecutado ? 6 : 5} className="text-right">
                  <strong>TOTAL CERTIFICADO:</strong>
                </td>
                <td className="text-right total-amount">
                  <strong>{formatearMoneda(certificacion.monto_total)}</strong>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

      {/* Observaciones */}
      {certificacion.observaciones && (
        <div className="observaciones-section">
          <h3>📝 Observaciones</h3>
          <p>{certificacion.observaciones}</p>
        </div>
      )}

      {/* Información de Aprobación */}
      {certificacion.aprobado_por && (
        <div className="aprobacion-info">
          <p>
            <strong>Aprobado por:</strong> {certificacion.aprobado_por}
          </p>
          {certificacion.fecha_aprobacion && (
            <p>
              <strong>Fecha de aprobación:</strong> {formatearFecha(certificacion.fecha_aprobacion)}
            </p>
          )}
        </div>
      )}
       

      {/* Modal Seleccionar Cliente */}
      <ModalSeleccionarCliente
        isOpen={modalClienteOpen}
        onClose={() => setModalClienteOpen(false)}
        onSelect={handleClienteSeleccionado}
        clientes={clientesDisponibles}
      />
    </div>
  );
};



export default DetalleCertificacion;